import { Component, inject, OnInit } from '@angular/core';
import { RulesGame } from '../../../shared/components/rules/rules-game/rules-game';
import { SelectLanguage } from '../../../shared/components/language/select-language/select-language';
import { UserProfile } from '../../../shared/components/profile/user-profile/user-profile';
import { Downtime } from '../../../core/services/times/downtime';
import { NavigationEnd, Router } from '@angular/router';
import { ConfigurationService } from '../../../core/services/configs/configuration';
import { ExitGame } from '../../../shared/components/buttons/exit-game/exit-game';
import { environment } from '../../../../environments/environment';


@Component({
  selector: 'app-header-component',
  imports: [ RulesGame, SelectLanguage, UserProfile, ExitGame],
  templateUrl: './header-component.html',
  host: {ngSkipHydration: 'true'},
  styleUrl: './header-component.scss'
})
export class HeaderComponent implements OnInit {
  downtime = inject(Downtime);
  router = inject(Router);
  configuration = inject(ConfigurationService);

  public settings = environment;
  

  isButtonExit: boolean = false;

  ngOnInit(): void {
    
    this.isButtonExit = false;
    this.router.events.subscribe(event => {
    if (event instanceof NavigationEnd) {
      
      if(event.url === "/"){
        this.downtime.ngOnDestroy(); 
      }else{
        let time = (this.configuration.configuration?.config?.idle_time)? this.configuration.configuration.config.idle_time/1000 : 900
        this.downtime.ngOnDestroy(); 
        this.downtime.init(time);
      }
      // event.url.includes('/waiting/') || event.url.includes('/lobby/') ||

      if( event.url.includes('/coop-game/')){
        this.isButtonExit = true;
      }else{
        this.isButtonExit = false;
      }
      if( event.url.includes('/single-game/')){
        this.isButtonExit = true;
      }else{
        this.isButtonExit = false;
      }
    }
  });
  } 

}
